<fgb-banner [pageTitle]="'terms.page.title'"></fgb-banner>

<fgb-page-header [showBalance]="false" [pageTitle]="'terms.page.title'" [backButtonLink]="'/'" />

<div class="container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <div class="row">
    <div class="col-12">
      <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">Loading...</p>
</ng-template>
